// Кэш запросов: повторяем только «нет связи» — отказ с причиной повтором не исправить.
import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "../api/client";

const NETWORK_RETRIES = 3;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) =>
          isApiError(error) && error.kind === "network" && failureCount < NETWORK_RETRIES,
        refetchOnWindowFocus: true,
        staleTime: 5_000,
      },
      mutations: { retry: false },
    },
  });
}
